import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Eye, EyeOff } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SignupFormProps {
    formData: {
        firstName: string;
        lastName: string;
        email: string;
        password?: string;
        confirmPassword?: string;
    };
    showPassword: boolean;
    setShowPassword: (show: boolean) => void;
    handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isDrawer?: boolean;
}

export const SignupForm: React.FC<SignupFormProps> = ({
    formData,
    showPassword,
    setShowPassword,
    handleInputChange,
    isDrawer
}) => {
    return (
        <div className={cn("space-y-4", isDrawer ? "px-4" : "")} dir="rtl">
            <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                    <Label htmlFor="firstName">שם פרטי <span className="text-destructive">*</span></Label>
                    <Input
                        id="firstName"
                        name="firstName"
                        type="text"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        placeholder="שם פרטי"
                        required
                        className="text-right"
                        dir="rtl"
                    />
                </div>
                <div className="space-y-2">
                    <Label htmlFor="lastName">שם משפחה <span className="text-destructive">*</span></Label>
                    <Input
                        id="lastName"
                        name="lastName"
                        type="text"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        placeholder="שם משפחה"
                        required
                        className="text-right"
                        dir="rtl"
                    />
                </div>
            </div>

            <div className="space-y-2">
                <Label htmlFor="email">כתובת מייל <span className="text-destructive">*</span></Label>
                <Input
                    id="email"
                    name="email"
                    type="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="הכנס את כתובת המייל שלך"
                    required
                    className="text-right"
                    dir="rtl"
                />
            </div>

            <div className="space-y-2">
                <Label htmlFor="password">סיסמה <span className="text-destructive">*</span></Label>
                <div className="relative">
                    <Input
                        id="password"
                        name="password"
                        type={showPassword ? 'text' : 'password'}
                        value={formData.password || ''}
                        onChange={handleInputChange}
                        placeholder="לפחות 6 תווים עם אות ומספר"
                        required
                        className="text-right pl-10"
                        dir="rtl"
                        minLength={6}
                    />
                    <Button
                        type="button"
                        variant="ghost"
                        size="sm"
                        className="absolute left-2 top-1/2 -translate-y-1/2 h-8 w-8 p-0 hover:bg-muted"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                        <span className="sr-only">
                            {showPassword ? 'הסתר סיסמה' : 'הצג סיסמה'}
                        </span>
                    </Button>
                </div>
            </div>

            <div className="space-y-2">
                <Label htmlFor="confirmPassword">אימות סיסמה <span className="text-destructive">*</span></Label>
                <div className="relative">
                    <Input
                        id="confirmPassword"
                        name="confirmPassword"
                        type={showPassword ? 'text' : 'password'}
                        value={formData.confirmPassword || ''}
                        onChange={handleInputChange}
                        placeholder="הקלד שוב את הסיסמה"
                        required
                        className="text-right pl-10"
                        dir="rtl"
                        minLength={6}
                    />
                    <Button
                        type="button"
                        variant="ghost"
                        size="sm"
                        className="absolute left-2 top-1/2 -translate-y-1/2 h-8 w-8 p-0 hover:bg-muted"
                        onClick={() => setShowPassword(!showPassword)}
                    >
                        {showPassword ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                        <span className="sr-only">
                            {showPassword ? 'הסתר סיסמה' : 'הצג סיסמה'}
                        </span>
                    </Button>
                </div>
            </div>
        </div>
    );
};
